// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  NewPlantMarginOverview,
  type PlantMarginOverview,
  type PlantMarginOverviewWireFormat,
} from '../PlantMarginOverview/PlantMarginOverview';

export class TenantMarginOverview {
  readonly id: string;
  readonly targetMarginPercentage: string;
  readonly minimumMarginPercentage: string;
  readonly targetMarginFlatAmount: string;
  readonly minimumMarginFlatAmount: string;
  readonly plants: PlantMarginOverview[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? '' : data.id;
    this.targetMarginPercentage =
      data.targetMarginPercentage === undefined ? '0' : data.targetMarginPercentage;
    this.minimumMarginPercentage =
      data.minimumMarginPercentage === undefined ? '0' : data.minimumMarginPercentage;
    this.targetMarginFlatAmount =
      data.targetMarginFlatAmount === undefined ? '0' : data.targetMarginFlatAmount;
    this.minimumMarginFlatAmount =
      data.minimumMarginFlatAmount === undefined ? '0' : data.minimumMarginFlatAmount;
    this.plants = (data.plants ?? []).map((plants: any) => NewPlantMarginOverview(plants));
  }

  static zero(): TenantMarginOverview {
    const zeroValues: ExcludeMethodsDeep<TenantMarginOverview> = {
      id: '',
      targetMarginPercentage: '0',
      minimumMarginPercentage: '0',
      targetMarginFlatAmount: '0',
      minimumMarginFlatAmount: '0',
      plants: [],
    };
    return new TenantMarginOverview(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TenantMarginOverviewWireFormat = {
  id: string;
  targetMarginPercentage: string;
  minimumMarginPercentage: string;
  targetMarginFlatAmount: string;
  minimumMarginFlatAmount: string;
  plants: PlantMarginOverviewWireFormat[];
};

type NewTenantMarginOverviewProps = PartialDeep<TenantMarginOverview, { recurseIntoArrays: true }>;
export const NewTenantMarginOverview: (
  props: NewTenantMarginOverviewProps,
) => TenantMarginOverview = (props) => new TenantMarginOverview(props);

type NewTenantMarginOverviewFromWireFormatProps = PartialDeep<
  TenantMarginOverviewWireFormat,
  { recurseIntoArrays: true }
>;
export const NewTenantMarginOverviewFromWireFormat: (
  props: NewTenantMarginOverviewFromWireFormatProps,
) => TenantMarginOverview = (props) => new TenantMarginOverview(props);
